<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('InvoiceInbounds.title_same_as_menu')}}</strong>
                <!--<span class="float-right">{{$t('InvoiceInbounds.text')}}</span>-->
                <div class="float-right">

                  <router-link :to="{ path: '/sbinvoiceinbound'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.new')}}</router-link>
                </div>
              </div>
              <div class="card-body card-block fColumn fColumn">
                <div class="fContent">

                  <div v-if="HelperRole.hasRights(state, [15],  [20])" class="row">
                    <div class="col-12  ">
                      <router-link :to="{ path: '/invoiceinboundnavrefresh'}" class="btn btn-primary"><i class="fa fa-link"></i> {{$t('InvoiceInboundNAVRefresh.new')}}</router-link>
                      <hr>
                    </div>
                  </div>
                  <div v-if="!HelperRole.hasRights(state, [15], false)" class=""></div>

                  <!--<div class="alert alert-warning">// Ez igazából nem kell.</div>-->


                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';

  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';
  import moment from 'moment';

  export default {
    name: 'SbInvoiceInbounds',
    data() {
      const modul = this;
      // "id","id_company","text"
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,

        data: [],
        head: [

          {
            modulname: modul.name,
            title: "InvoiceInbounds.dttitle",
            data: "id",
            link: true,
            linkurl: "sbinvoiceinbound",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // InvoiceInbounds.linktext
          }
          , {
            key: "text",
            title: "",
//            searchField: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.text) {
                return "fa fa-info-circle nowrap rowcolorred";
              } else {
                return "";
              }
            },
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return ""
            },
          }
          , {
            key: "text2",
            title: "",
//            searchField: true,
            classth: "d-none",
            classtd: "d-none",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//                return "";
//            },
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return ""
            },
          }
          , {
            key: "recording_type",
            title: "InvoiceInbounds.recording_type",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//            return ""
//            },
//            searchField: true,
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.recording_type === "H") {
                return modul.$t("InvoiceInbounds.H");
              } else if (dataRow.recording_type === "N") {
                return modul.$t("InvoiceInbounds.N");
              } else {
                return ""
              }
            },
          }
          , {
            xlsfield: true,
            key: "wf_status",
            searchField: true,
            i18Key: "InvoiceInbound.wf_statuses_short",
            title: "InvoiceInbounds.wf_status",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              if (dataRow.wf_status && dataRow.wf_status === "UPLOADING") {
                return " " + ""; // text-nowrap
              }
              if (dataRow.wf_status && dataRow.wf_status === "ACCEPTED") {
                return "rowstgreen " + ""; // text-nowrap
              }
              if (dataRow.wf_status && dataRow.wf_status === "REJECTED") {
                return "rowstgray " + ""; // text-nowrap
              }
              return "";
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "identifier",
            title: "Document.identifier",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              // a sumnum a képek hozzá feltöltött képek száma
              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
                return "rowgreen";
              }
              if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
                return "rowyellow";
              }
              return "rowred";


//              if (HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                  return "rowgreen";
//                }
//                if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                  return "rowyellow";
//                }
//                return "rowred";
//              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
//                  return "rowgreen";
//                }
//                if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
//                  return "rowyellow";
//                }
//                return "rowred";
////                return "";
//
//              }


//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
          }
          , {
            xlsfield: true,
            xlsfieldNumber: true,
            searchField: true,
            key: "price_sum",
            sortConvertType: "number",
            title: "InvoiceInbounds.price_sum_in_huf",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {

              let user_sumprice_huf_number_of_decimals = (Number(modul.user_sumprice_huf_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_huf_number_of_decimals) : 3;
              let user_sumprice_eur_number_of_decimals = (Number(modul.user_sumprice_eur_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_eur_number_of_decimals) : 3;
              let user_sumprice_usd_number_of_decimals = (Number(modul.user_sumprice_usd_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_usd_number_of_decimals) : 3;

              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_huf_number_of_decimals) {
                user_sumprice_huf_number_of_decimals = modul.state.usersettings.user_sumprice_huf_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_eur_number_of_decimals) {
                user_sumprice_eur_number_of_decimals = modul.state.usersettings.user_sumprice_eur_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_usd_number_of_decimals) {
                user_sumprice_usd_number_of_decimals = modul.state.usersettings.user_sumprice_usd_number_of_decimals
              }
//              ,user_sumprice_huf_number_of_decimals
//                ,user_sumprice_eur_number_of_decimals
//                ,user_sumprice_usd_number_of_decimals
              return Helper.getFormattedPriceSegmentation(dataRowheadRowkey, user_sumprice_huf_number_of_decimals);
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "dt_make",
            title: "InvoiceInbounds.dt_make",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            key: "dt_completion",
            title: "InvoiceInbounds.dt_completion",
            searchField: true,
            xlsfield: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "dt_needtransfer",
            title: "InvoiceInbounds.dt_needtransfer",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "payment_type",
            title: "Document.payment_type",
            searchField: true,
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('InvoiceInbounds.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('InvoiceInbounds.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('InvoiceInbounds.paymenttype3');
              } else {
                return "";
              }
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('Document.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('Document.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('Document.paymenttype3');
              } else {
                return "";
              }
            }
          }
          , {
            xlsfield: true,
            key: "from_taxnumber",
            title: "Document.from_taxnumber",
            searchField: true
          }
          , {
            xlsfield: true,
            key: "from_name",
            sortConvertType: "lowercase",
            title: "Document.from_businesspartnername",
            searchField: true,
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              const data = dataRow.from_name;
              let ret = data;
              if (typeof data === "string") {
                if (data.length > 15) {
                  ret = data.substr(0, 15) + "...";
                }
              }
              return ret;
            },
          }
          , {
            xlsfield: true,
            xlsfieldNumber: true,
            xlsrender: false,
            searchField: true,
            key: "price_sumactualdeviza",
            sortConvertType: "number",
            title: "InvoiceInbounds.price_sum_act_dev",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {

              let user_sumprice_huf_number_of_decimals = (Number(modul.user_sumprice_huf_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_huf_number_of_decimals) : 0;
              let user_sumprice_eur_number_of_decimals = (Number(modul.user_sumprice_eur_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_eur_number_of_decimals) : 2;
              let user_sumprice_usd_number_of_decimals = (Number(modul.user_sumprice_usd_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_usd_number_of_decimals) : 2;

              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_huf_number_of_decimals) {
                user_sumprice_huf_number_of_decimals = modul.state.usersettings.user_sumprice_huf_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_eur_number_of_decimals) {
                user_sumprice_eur_number_of_decimals = modul.state.usersettings.user_sumprice_eur_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_usd_number_of_decimals) {
                user_sumprice_usd_number_of_decimals = modul.state.usersettings.user_sumprice_usd_number_of_decimals
              }

              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sumactualdeviza"], user_sumprice_huf_number_of_decimals)
              } else if (dataRow.currency === "EUR") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sumactualdeviza"], user_sumprice_eur_number_of_decimals)
              } else if (dataRow.currency === "USD") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sumactualdeviza"], user_sumprice_usd_number_of_decimals)
              }
              return ret;
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = dataRow["price_sum"]
              } else if (dataRow.currency === "EUR") {
                ret = dataRow["price_sum_currency"]
              } else if (dataRow.currency === "USD") {
                ret = dataRow["price_sum_currency"]
              }
              return ret;
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "currency",
            title: "InvoiceInbounds.currency",
          },
//
//          {
//            modulname: modul.name,
//            title: "InvoiceInbounds.dttitle",
//            data: "id",
//            link: true,
//            linkurl: "sbinvoiceinbound",
//            linkclass: "text-nowrap",
//            linkiconclass: "menu-icon fa fa-edit btn-link",
//            linktext: "", // InvoiceInbounds.linktext
//          }
//          , {
//            key: "wf_status",
//            title: "InvoiceInbounds.wf_status",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//
//              if (dataRow.wf_status && dataRow.wf_status === "UPLOADING") {
//                return "";
//              }
//              if (dataRow.wf_status && dataRow.wf_status === "ACCEPTED") {
//                return "rowstgreen";
//              }
//              if (dataRow.wf_status && dataRow.wf_status === "REJECTED") {
//                return "rowstgray";
//              }
//              return "";
////              if (Number(dataRow.price_sum) > 0) {
////              } else {
////              }
//
//            },
//          }
//          , {
//            key: "identifier",
//            title: "Document.identifier",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//
//              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                return "rowgreen";
//              }
//              if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                return "rowyellow";
//              }
//              return "rowred";
////              if (Number(dataRow.price_sum) > 0) {
////              } else {
////              }
//
//            },
//            searchField: true
//          }
//          , {
//            key: "price_sum",
//            title: "InvoiceInbounds.price_sum",
//          }
//          , {
//            key: "dt_make",
//            title: "InvoiceInbounds.dt_make",
//          }
//          , {
//            key: "dt_needtransfer",
//            title: "InvoiceInbounds.dt_needtransfer",
//          }
//          , {
//            key: "from_name",
//            title: "Document.from_businesspartnername",
//          }
//
//          , {
//            key: "from_businesspartnername",
//            title: "Document.from_businesspartnername",
//          }


//          , {
//            key: "deleted",
//            title: "global.deleted",
//            searchField: true
//          }


        ]
        , breadcrumbstitle: 'InvoiceInbounds.title'
        , breadcrumbsData: [
          {
            'title': "InvoiceInbounds.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();

      const copiedState = Object.assign({}, modul.$store.state);
      const newState = Object.assign(copiedState, {lastVisitedListForRedirection: "sbinvoiceinbounds"});
      modul.$store.replaceState(newState);

    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [18, 20])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElements();

      },
      handlePayedHandler(event, data, type, row, meta){
        console.log(event, row);
        const modul = this;

        const fnCb = function () {
          const dt_transfer = moment().format('YYYY-MM-DD');
          const id = row.id;
          console.log(JSON.stringify(row));
          const postData = {
            dt_transfer: dt_transfer,
            transfered: "1"
          }
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveInvoiceInboundTransfered({id_company: modul.$store.state.id_company, id: id, data: postData}).then(function (res) {
            if (res && res.result) {
              if (Helper.Number(res.data.transfered) === 1) {
                modul.getElements();
              }
            }

//          const res = result;
//          modul.data = Array.from(result);
            console.log(res);
//          console.log(modul);
//          console.log("modul.state");
//          console.log(modul.state);
//          console.log("modul.state.appVersion");
//          console.log(modul.state.appVersion);
//            modul.AlertInPage.msg = "";

            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(2000));

          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });


        }
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("InvoiceInbounds.settransfered_question"),
          tmsgText: "",
          fnCancel: function () {
            console.log('fnCancel')
          },
          fnConfirm: function () {
            console.log('fnConfirm')
            fnCb()
          }
        });


      },

//      modulRowIdCb: function (data, type, row, meta) {
//        const modul = this;
//        console.log("--" + data);
//        return "" + row.identifier_pre_id + row.identifier_counter;
//      },
//      renderType(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return modul.$t("global.contacttype.businesspartner")
//        }
//        if (Number(row.id_store)>0) {
//          return modul.$t("global.contacttype.store")
//        }
//        if (Number(row.id_address)>0) {
//          return modul.$t("global.contacttype.address")
//        }
//      },
//      renderEntity(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return row.businesspartnerbusinesspartnername;
//        }
//        if (Number(row.id_store)>0) {
//          return row.storetext;
//        }
//        if (Number(row.id_address)>0) {
//          return row.addressname;
//        }
//      },
//      chkRole(){
//        const modul = this;
//        modul.hasRole = false;
//        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        if (!Helper.checkRoles(modul.roles, role)) {
//          modul.hasRole = false;
////        modul.$router.push({name: "dashboard"})
//        } else {
//          modul.hasRole = true;
//        }
//      },
      getElements(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getSbInvoiceInbounds({id_company: modul.$store.state.id_company, data: {additionalimages: true}}).then(function (res) {
          if (res && res.result) {
            modul.data = Array.from(res.data);
          }

//          const res = result;
//          modul.data = Array.from(result);
          console.log(res);
//          console.log(modul);
//          console.log("modul.state");
//          console.log(modul.state);
//          console.log("modul.state.appVersion");
//          console.log(modul.state.appVersion);
          modul.AlertInPage.msg = "";

        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      }
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
    },
  };
</script>


<style @scoped="">

</style>





